import React, { ReactNode } from "react";
import { VersionNode } from "./VersionNode";
import { BaseScaleNode } from "./BaseScaleNode";
import { RootNode } from "./RootNode";
import { RootDimsNode } from "./RootDimsNode";

export function renderRootNodesContent(data: { [key: string]: any } | number | string, path: string[]): ReactNode {
  const priorityKeys = ["__version", "baseScale", "dims", "root"];
  const sortWithPriority = (a: [string, any], b: [string, any]) => {
    const indexA = priorityKeys.indexOf(a[0]);
    const indexB = priorityKeys.indexOf(b[0]);
    if (indexA !== -1 && indexB !== -1) return indexA - indexB; // Both keys are in priority list
    if (indexA !== -1) return -1; // Only A is in priority list
    if (indexB !== -1) return 1; // Only B is in priority list
    return 0; // Neither key is in priority list
  };

  return Object.entries(data)
    .sort(sortWithPriority)
    .map(([propName, value]) => {
      let uniqueKey = path.concat([propName]).join("/");

      if (["__statsTable", "__statsInFeedback", "__optionsInFeedback"].includes(propName)) {
        return null;
      }

      if (typeof value === "string" && propName === "__version") {
        return <VersionNode key={uniqueKey} componentName={propName} value={value} />;
      } else if (propName === "baseScale") {
        return <BaseScaleNode key={uniqueKey} scale={value} />;
      } else if (propName === "dims") {
        return <RootDimsNode key={uniqueKey} value={value} />;
      }

      return <RootNode key={uniqueKey} value={value} path={path} uniqueKey={uniqueKey} pieceName={propName}></RootNode>;
    });
}
